import { Component, OnInit, DoCheck } from '@angular/core';
import { Router } from '@angular/router';

import { Order, OrderDish, OrderReservation } from '../../models/order';
import { Reservation } from '../../models/reservation';

import { ReservationService } from '../../services/reservation.service';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-order-add',
  templateUrl: './order-add.component.html',
  styleUrls: ['./order-add.component.css']
})

export class OrderAddComponent implements OnInit, DoCheck {
  extraDishes: OrderDish[];
  errorMessage: string;
  reservations: Reservation[];
  reservationReference: string;
  isAddingReservation = false;
  isLoadingDishes = true;
  totalPrice: Number = 0;

  constructor(private reservationService: ReservationService, private orderService: OrderService, private router: Router) {

  }

  ngOnInit() {
    this.reservations = new Array<Reservation>();
    this.extraDishes = new Array<OrderDish>();

    this.reservationService.getDishes().subscribe(dishes => {
      for (let i = 0; i < dishes.length; i++) {
        const orderDish = new OrderDish();
        orderDish.dishId = dishes[i].id;
        orderDish.dishName = dishes[i].name;
        orderDish.count = 0;
        orderDish.unitPrice = dishes[i].price;
        this.extraDishes.push(orderDish);
      }
      this.isLoadingDishes = false;
    });
  }

  ngDoCheck() {
    this.calculateTotal();
  }

  calculateTotal() {
    let total = 0;
    this.extraDishes.forEach(dish => {
      total += (dish.count * dish.unitPrice);
    });

    this.reservations.forEach(res => {
      if (!res.isPaid) {
        res.dishes.forEach(dish => total += (dish.count * dish.unitPrice));
      }
    });
    this.totalPrice = total;
  }

  addReservation() {
    this.errorMessage = '';
    if (this.reservationReference) {
      if (this.reservations.filter(r => (r.externalRef + '') === (this.reservationReference + '')).length === 0) {
        this.isAddingReservation = true;
        this.reservationService.getReservation(this.reservationReference).subscribe(res => {
          if (res.state > 10) {
            this.errorMessage = 'Reservatie ' + res.externalRef + ' is niet meer beschikbaar';
          } else {
            this.reservations.push(res);
            this.reservationReference = '';
          }
          this.isAddingReservation = false;
        }, err => {
          if (err.status === 404) {
            this.errorMessage = 'Reservatie niet gevonden';
          } else {
            this.errorMessage = 'Something went wrong -> ' + err.error + ' (' + err.status + ')';
          }
          this.isAddingReservation = false;
        });
      } else {
        this.errorMessage = 'Reservatie is reeds toegevoegd';
      }
    }
  }

  removeReservation(id: number) {
    this.errorMessage = '';
    const index = this.reservations.findIndex(res => res.id === id);
    this.reservations.splice(index, 1);
  }

  saveOrder() {
    this.errorMessage = '';
    let order: Order = new Order();
    order.dishes = this.extraDishes.filter(dish => dish.count > 0).map(dish => {
      let orderDish = new OrderDish();
      orderDish.dishId = dish.dishId;
      orderDish.count = dish.count;
      return orderDish;
    });
    order.reservations = this.reservations.map(this.reservationToOrderReservation);
    this.orderService.saveOrder(order).subscribe(x => this.router.navigateByUrl('/sale/' + x.id),
      err => this.errorMessage = 'Something went wrong -> ' + err.error + ' (' + err.status + ')');
  }

  reservationToOrderReservation(reservation: Reservation): OrderReservation {
    let orderReservation = new OrderReservation();
    orderReservation.idReservation = reservation.id;
    orderReservation.dishes = reservation.dishes.map(dish => {
      let orderDish = new OrderDish();
      orderDish.dishId = dish.dishId;
      orderDish.count = dish.count;
      return orderDish;
    });
    return orderReservation;
  }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/pages/order-add/order-add.component.ts